var render, staticRenderFns
import script from "./ConferenceStand.vue?vue&type=script&lang=js&"
export * from "./ConferenceStand.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceStand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01c921fb')) {
      api.createRecord('01c921fb', component.options)
    } else {
      api.reload('01c921fb', component.options)
    }
    
  }
}
component.options.__file = "module/Vrcci/Conference/resources/vue/ConferenceStand.vue"
export default component.exports